import { useEffect, useState } from 'react';

import {
    MenuItem,
    Checkbox,
    TextField,
    FormControl,
    InputLabel,
    Select,
    ListItemText
} from '@mui/material';

import { spliceString } from '../../utils/formatString'

import { inputTypes, inputTypesDef } from "../../schema/customFields/customFieldSchema"

import { useAppContextFeatures } from '../../context/AppContext'
import { useSystemPrompt } from '../useSystemPrompt';

import { useCustomFields } from '../api/useCustomFields';

export function useStateCustomFields(props) {

    const {
        fieldModule,
        moduleFunction
    } = props?.fieldModule ? props : {}


    const { list: listCustomFields, filterOperatorTypes } = useCustomFields({ customFieldModule: fieldModule, customFieldFunction: moduleFunction })
    const [dataCustomFields, setDataCustomFields] = useState([])

    const { setSystemLoading } = useAppContextFeatures()

    const { promptMessage } = useSystemPrompt()

    const fetchCustomFields = async () => {

        setSystemLoading(true)

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: "field_module",
                        operator: filterOperatorTypes.eq,
                        value: fieldModule
                    },
                    {
                        name: "module_function",
                        operator: filterOperatorTypes.eq,
                        value: moduleFunction
                    },
                    {
                        name: "status",
                        operator: filterOperatorTypes.eq,
                        value: "1"
                    }
                ]
            };

            const response = await listCustomFields(props);

            setSystemLoading(false)

            const _cf = response?.data?.custom_fields

            setDataCustomFields(_cf)

            return _cf

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

        return false

    }

    const getInitialFormStateRows = async ({
        savedCustomFields
    }) => {

        let returnCF = []

        let allCustomFields = await fetchCustomFields()

        // console.log('savedCustomFields', savedCustomFields, allCustomFields)

        // check the saved cf still valid in the list of enabled custom fields
        allCustomFields.forEach((e1) => {

            let checkExists = savedCustomFields.filter(i => i.id === e1.id)

            // console.log('checkExists', checkExists)

            let fieldKey = e1?.field_key

            let defFields = {
                customFieldId: e1?.id ? e1.id : "",
                name: e1?.field_label ? e1.field_label : "",
                fieldLabel: e1?.field_label,
                fieldType: e1?.field_type,
                fieldKey: e1?.field_key
            }

            if (checkExists.length > 0) {

                let i = checkExists[0]
                let customValue = "";
                let customArray = [];

                if (e1?.field_type === inputTypesDef.textbox) {
                    customValue = i.value
                } else if (e1?.field_type === inputTypesDef.dropdown) {

                    let a = getCustomFieldOptionKeyByValue(i?.value, allCustomFields, fieldKey)

                    customArray = a.length <= 0 ? [""] : [a[a.length - 1]]

                } else if (e1?.field_type === inputTypesDef.multidropdown) {

                    let a = getCustomFieldOptionKeyByValue(i?.value, allCustomFields, fieldKey)
                    customArray = a
                    // console.log('a', a, i.value, customFields)
                }

                returnCF.push({
                    customValue,
                    customArray,
                    ...defFields
                })

            } else { // mean is never saved before

                returnCF.push({
                    customValue: "",
                    customArray: [],
                    ...defFields
                })
            }


        })

        return returnCF
    }

    const getSubmitFormDataFromRows = ({ rows }) => {

        let cf = []

        // console.log('rows', rows)

        rows.forEach(e => {

            let item = {
                custom_field_id: e?.customFieldId
            }

            let fieldType = e?.fieldType;
            // getCustomFieldType(dataCustomFields, e?.customFieldId)

            if (fieldType === inputTypesDef.textbox) {
                item = { ...item, custom_field_value: e?.customValue }
            } else if (fieldType === inputTypesDef.dropdown) {
                item = { ...item, custom_field_value: e?.customArray }
            } else if (fieldType === inputTypesDef.multidropdown) {
                item = { ...item, custom_field_value: e?.customArray }
            }

            cf.push(item)

        })

        return cf
    }

    const getCustomFieldType = (id) => {

        if (!id) return ""

        const a = dataCustomFields.filter(i => i.id === id)

        return a.length ? a[0].field_type : ""

    }

    const getCustomFieldOptions = (id) => {

        if (!id) return []

        const a = dataCustomFields.filter(i => i.id === id)
        return a ? a[0].options : []
    }

    const getCustomFieldOptionKeyByValue = (valueArray, allCustomFields, fieldKey) => {

        let cf = allCustomFields

        if (!valueArray) return []

        let optionKeys = [];

        let selectedCF = cf.filter(i => i.field_key === fieldKey)

        selectedCF.forEach((e) => {
            e.options.forEach((e2) => {
                if (valueArray.includes(e2.option_name)) {
                    optionKeys.push(e2.option_key)
                }
            })
        })

        return optionKeys
    }

    const getCustomFieldOptionNameByIds = (optionIdArray, allCustomFields, fieldKey) => {

        let cf = allCustomFields

        if (!optionIdArray) return []

        let optionNames = [];

        let selectedCF = cf.filter(i => i.field_key === fieldKey)

        selectedCF.forEach((e) => {
            e.options.forEach((e2) => {
                // if(e2.option_key === optionIdArray){
                if (optionIdArray.includes(e2.option_key)) {
                    optionNames.push(e2.option_name)
                }
            })
        })

        return optionNames
    }

    const RenderCustomFieldSelectionTextbox = ({
        // itemValues,
        // itemErrors,
        // itemTouched,
        // index,
        inputProps

    }) => {

        // console.log('text', inputProps)

        return (

            <TextField
                margin="dense"
                size="small"
                {...inputProps}
            />

        )
    }

    const RenderCustomFieldSelectionDropdown = ({
        itemValues,
        // itemErrors,
        // itemTouched,
        // index,
        item,
        selectProps
    }) => {

        // console.log('drop', selectProps)

        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
            // error={itemTouched.customArray && Boolean(itemErrors.customArray)}
            >
                <InputLabel id="customValue">{item?.field_label}</InputLabel>
                <Select
                    {...selectProps}
                >

                    {
                        getCustomFieldOptions(itemValues?.customFieldId).map((i, index2) => {
                            return (
                                <MenuItem
                                    key={index2}
                                    value={i?.option_key}
                                >
                                    <ListItemText primary={`${i.option_name}`} />
                                </MenuItem>
                            )
                        })
                    }
                </Select>
                {/* <FormHelperText>
                    {itemTouched.customArray && itemErrors.customArray}
                </FormHelperText> */}
            </FormControl>
        )
    }

    const RenderCustomFieldSelectionMultiDropdown = ({
        // item,
        itemValues,
        // itemErrors,
        // itemTouched,
        // index,
        selectProps
    }) => {

        // console.log('multi', selectProps)

        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
            // error={itemTouched.customArray && Boolean(itemErrors.customArray)}
            >
                <InputLabel id="customArray">{itemValues?.fieldLabel}</InputLabel>
                <Select
                    {...selectProps}
                >

                    {
                        getCustomFieldOptions(itemValues?.customFieldId).map((i, index2) => {
                            return (
                                <MenuItem
                                    key={index2}
                                    value={i?.option_key}
                                >
                                    <Checkbox checked={itemValues.customArray.indexOf(i?.option_key) > -1} />
                                    <ListItemText primary={`${spliceString({ val: i.option_name, maxLength: 50 })}`} />
                                </MenuItem>
                                // <option key={i.option_name} value={i.option_name}>
                                //     {i.option_name}
                                // </option>
                            )
                        })
                    }
                </Select>
                {/* <FormHelperText>
                    {itemTouched.customArray && itemErrors.customArray}
                </FormHelperText> */}
            </FormControl>
        )
    }

    return {
        // isLoading,
        dataCustomFields,
        fetchCustomFields,

        getInitialFormStateRows,
        getSubmitFormDataFromRows,

        getCustomFieldType,
        getCustomFieldOptions,
        getCustomFieldOptionKeyByValue,
        getCustomFieldOptionNameByIds,

        RenderCustomFieldSelectionTextbox,
        RenderCustomFieldSelectionDropdown,
        RenderCustomFieldSelectionMultiDropdown

    }

}